<template>
  <div class="d-none"></div>
</template>
<script>


export default {
  mounted()
  {

      var lang = document.documentElement.getAttribute('lang');

      if (lang === "de")
      {
        // Do something with the lang variable
        var trustamiScript = document.createElement('script');

        trustamiScript.id = 'trustamiwidget';
        trustamiScript.type = 'text/javascript';
        trustamiScript.src = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
        trustamiScript.setAttribute('data-profile', '6417640953a499484c8b4568');
        trustamiScript.setAttribute('data-user', '6eb547f71a0232f943eb1d9b653fb7016173bdbc');
        trustamiScript.setAttribute('data-platform', '0');
        trustamiScript.setAttribute('data-languageid', '2');
        trustamiScript.async = true;

// Append the script element to the head of the document
        document.head.appendChild(trustamiScript);
      } else if (lang === "fr") {
        var trustamiScript = document.createElement('script');

        trustamiScript.id = 'trustamiwidget';
        trustamiScript.type = 'text/javascript';
        trustamiScript.src = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
        trustamiScript.setAttribute('data-profile', '6417640953a499484c8b4568');
        trustamiScript.setAttribute('data-user', '6eb547f71a0232f943eb1d9b653fb7016173bdbc');
        trustamiScript.setAttribute('data-platform', '0');
        trustamiScript.setAttribute('data-languageid', '3');
        trustamiScript.async = true;

// Append the script element to the head of the document
        document.head.appendChild(trustamiScript);
      } else if (lang === "it") {
        var trustamiScript = document.createElement('script');

        trustamiScript.id = 'trustamiwidget';
        trustamiScript.type = 'text/javascript';
        trustamiScript.src = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
        trustamiScript.setAttribute('data-profile', '6417640953a499484c8b4568');
        trustamiScript.setAttribute('data-user', '6eb547f71a0232f943eb1d9b653fb7016173bdbc');
        trustamiScript.setAttribute('data-platform', '0');
        trustamiScript.setAttribute('data-languageid', '4');
        trustamiScript.async = true;

// Append the script element to the head of the document
        document.head.appendChild(trustamiScript);
      } else if (lang === "es") {
        var trustamiScript = document.createElement('script');

        trustamiScript.id = 'trustamiwidget';
        trustamiScript.type = 'text/javascript';
        trustamiScript.src = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
        trustamiScript.setAttribute('data-profile', '6417640953a499484c8b4568');
        trustamiScript.setAttribute('data-user', '6eb547f71a0232f943eb1d9b653fb7016173bdbc');
        trustamiScript.setAttribute('data-platform', '0');
        trustamiScript.setAttribute('data-languageid', '5');
        trustamiScript.async = true;

// Append the script element to the head of the document
        document.head.appendChild(trustamiScript);
      }  else {
        var trustamiScript = document.createElement('script');

        trustamiScript.id = 'trustamiwidget';
        trustamiScript.type = 'text/javascript';
        trustamiScript.src = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
        trustamiScript.setAttribute('data-profile', '6417640953a499484c8b4568');
        trustamiScript.setAttribute('data-user', '6eb547f71a0232f943eb1d9b653fb7016173bdbc');
        trustamiScript.setAttribute('data-platform', '0');
        trustamiScript.setAttribute('data-languageid', '1');
        trustamiScript.async = true;

// Append the script element to the head of the document
        document.head.appendChild(trustamiScript);
      }
  },
}
</script>